import React, { Component } from "react";
import { Button, Menu, Dimmer, Loader } from "semantic-ui-react";
import { Link } from "react-router-dom";

export default class HeaderMenu extends Component {
  render() {
    const { IsUserLoggedIn, history, onLogOut, isLoading } = this.props;
    return (
      <Menu size="large">
        <Menu.Item>
          <Link to="/">Home</Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/topTenLikes">Top Ten Likes</Link>
        </Menu.Item>
        {/* <Menu.Item>
          <Link to="/how-to-submit">
            <div className="card" content="Run">
              How to submit url by using app?
            </div>
          </Link>
        </Menu.Item> */}
        <Menu.Menu position="right">
          <Menu.Item>
            <Link to="/submitURL">
              <Button primary>Submit URL</Button>
            </Link>
          </Menu.Item>
          <Dimmer.Dimmable dimmed={isLoading}>
            <Dimmer active={isLoading} inverted={true}>
              <Loader></Loader>
            </Dimmer>
            {!IsUserLoggedIn ? (
              <div style={{ display: "inline-flex" }}>
                <Menu.Item>
                  <Link to="/login">
                    <Button>Log in</Button>
                  </Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to="/register">
                    <Button>Sign Up</Button>
                  </Link>
                </Menu.Item>
              </div>
            ) : (
              <div style={{ display: "inline-flex" }}>
                <Menu.Item>
                  <Link to="/userDashboard">
                    <Button>Dashboard</Button>
                  </Link>
                </Menu.Item>
                <Menu.Item>
                  <Button onClick={() => onLogOut(history)}>Logout</Button>
                </Menu.Item>
              </div>
            )}
          </Dimmer.Dimmable>
        </Menu.Menu>
      </Menu>
    );
  }
}
